import type { User } from "@/lib/api-types";

/**
 * A student has finished onboarding once name, class, phone and school are all
 * on their row. Mirror of is_profile_complete in backend/shared/validation.mjs,
 * which enforces the same rule on PUT /users/me.
 */
export function isProfileComplete(user: Pick<User, "user_name" | "class_id" | "phone" | "school_name"> | null | undefined): boolean {
  return !!user && !!user.user_name && !!user.class_id && !!user.phone && !!user.school_name;
}
